import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceApiNestingale } from "../../axios";
export const saveTemplateThunk = createAsyncThunk(
    "builder/saveTemplate",
    async (config: {}, { rejectWithValue, getState }) => {
        try {
            let url = `v1/api/templates`;
            let method = 'post';
            const methodHandlers = {
                post: axiosInstanceApiNestingale.post,
                put: axiosInstanceApiNestingale.put,
            };
            const templateJson: any = Object.assign({}, (getState() as any).builder.template.templateData); //need to change the path of the state
            const templateId = templateJson.templateId;
            if (templateId) {
                url += `/${templateId}`;
                method = 'put';
                delete templateJson.templateId;
            }

            //@ts-ignore
            const result = await methodHandlers[method](url, templateJson,
                {
                    // headers: {
                    //     'Designer-Id': 'f67dcdb5-7806-4063-ae08-18127a83eddf'
                    // }
                })
                .then((response: any) => {
                    return response.data
                }, (err: any) => {
                    const errorObj = Object.assign({ description: "NEST_SPA:Slices:saveProject:Exception", errorCode: "NEST_SPA:BUILDER_PAGE:SAVE_PROJECT" }, err)
                    console.log(errorObj);
                    throw errorObj;
                });
            console.log("Project saved :: ", result);
            // return templateId || result.templateId;
            return result;
        } catch (err) {
            console.log({ description: "NEST_SPA:Slices:saveProject:Exception", errorCode: "NEST_SPA:BUILDER_PAGE:SAVE_PROJECT", err_desc: (err as Error).message, err_stack: (err as Error).stack });
            return rejectWithValue(err);
        }
    }
);

export const fetchTemplateDataThunk = createAsyncThunk(
    'template/fetchTemplateData',
    async (templateId: string, { rejectWithValue }) => {
        try {
            const response = await axiosInstanceApiNestingale.get(`v1/api/template/${templateId}`, {
                // headers: {
                //     'Designer-Id': 'f67dcdb5-7806-4063-ae08-18127a83eddf'
                // },
                timeout: 10000,
            });

            if (response.status !== 200) {
                return rejectWithValue(`Unexpected response: ${response.status}`);
            }
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data?.message || 'Server error');
            } else if (error.request) {
                return rejectWithValue('No response from server. Please try again.');
            } else {
                return rejectWithValue(error.message || 'Something went wrong');
            }
        }
    }
);

export const deleteTemplateThunk = createAsyncThunk(
    'template/deleteTemplate',
    async (templateId: string, { rejectWithValue }) => {
        try {
            const response = await axiosInstanceApiNestingale.delete(`v1/api/templates/${templateId}`, {
                // headers: {
                //     'Designer-Id': 'f67dcdb5-7806-4063-ae08-18127a83eddf'
                // },
                timeout: 10000,
            });

            if (response.status !== 200 && response.status !== 204) {
                return rejectWithValue(`Unexpected response: ${response.status}`);
            }

            return { templateId }; // return any identifier for success handling
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data?.message || 'Server error');
            } else if (error.request) {
                return rejectWithValue('No response from server. Please try again.');
            } else {
                return rejectWithValue(error.message || 'Something went wrong');
            }
        }
    }
);
